import React from 'react';
import { Card, Button, Alert, Form, InputGroup } from 'react-bootstrap';
import { formatDate, formatCurrency } from '../../utils/formatters';
import Required from '../../utils/Required';

const BillingStatementsCard = ({
  bills,
  selectedBill,
  onBillSelect,
  onViewBill,
  onDownloadAll
}) => {

  return (
    <Card className="shadow mb-4">
      <Card.Header>
        <h5 className="mb-0">Billing Statements</h5>
      </Card.Header>
      <Card.Body>
        {bills?.length > 0 ? (
          <>
            <Form.Group className="d-flex gap-2 mb-3">
              <InputGroup>
                <Form.FloatingLabel label="Select a Bill" controlId="select-bill">
                <Form.Select
                  value={selectedBill}
                  onChange={(e) => onBillSelect(e.target.value)}
                >
                  <option value="">...</option>
                  {bills.map((bill, i) => (
                    <option key={`bill-${bill.billId}-${i}`} value={bill.billId}>
                      {formatDate(bill.billDate)} - {bill.currentAmount != null ? formatCurrency(bill.currentAmount) : 'Not Available'}
                    </option>
                  ))}
                </Form.Select>
                </Form.FloatingLabel>
              </InputGroup>
              <Button
                variant="primary"
                onClick={onViewBill}
                disabled={!selectedBill}
              >
                View
              </Button>
            </Form.Group>
            <Button
              variant="outline-primary"
              className="w-100"
              onClick={onDownloadAll}
            >
              Download All Statements (ZIP)
            </Button>
          </>
        ) : (
          <Alert variant="info" className="mb-0">
            No billing statements available.
          </Alert>
        )}
      </Card.Body>
    </Card>
  );
};

export default BillingStatementsCard;
